<template>
      <li @click="selectValue(label,value)" :class="{colorChange:changeIndex === label}">{{label}}</li>
</template>

<script>
    export default {
        name: "select-option",
      data(){
        return{
          changeIndex:'',
        }
      },
      props:{
        page_size:String,
        label:String,
        value:String,
      },
      methods:{
        selectValue:function(label,value){
          this.changeIndex = label;
          setTimeout(()=>{
            this.changeIndex = '';
          },200);
          console.log(value);
          this.$emit('update:changeValue',value);
          this.$emit('update:changeLabel',label);
        }
      }
    }
</script>

<style scoped>
li{
  cursor: pointer;
}
  .colorChange{
    color:blue;
  }
</style>



// WEBPACK FOOTER //
// src/components/selectOption.vue